// extracted by mini-css-extract-plugin
export default {"layout":"TallSingleBlock_layout__PjT6a","container":"TallSingleBlock_container__a38sA"};